module.exports = __webpack_public_path__ + "static/media/9DESA9.50c5102c.jpg";